export default "__VITE_ASSET__d3149b2f__"